import {Pipe, PipeTransform} from '@angular/core';
import {OuvragesUtils} from 'app/shared/utils/ouvrages.utils';

/**
 * Renvoie le texte à afficher pour une qualification.
 */
@Pipe({name: 'paramQualifText'})
export class ParamQualifTextPipe implements PipeTransform {

    constructor() {
    }

    transform(qualif: string): string {
        return OuvragesUtils.getParametreQualifText(qualif);
    }
}
